module.exports = __webpack_public_path__ + "static/media/img_header_congresses_mobile.54e97b67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/congresses/assets/img_header_congresses_mobile.jpg
// module id = 1134
// module chunks = 1